import { Field } from 'formik';
import React, { useEffect, useCallback, useMemo } from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { FormikCheckBox, FormikTimeInput } from '../../../components';
import useTimeCalculation from '../../../../hooks/useTimeCalculation';

const Flexibility = ({ currentTab, disabled, errors, getIn, onChangeTab, setFieldValue, touched, values }) => {
  const {
    flexibleShift,
    initialTime,
    lunchTime,
    shiftDaysAttributes,
    workHours,
    imputableColation,
    agreedSchedule
  } = values.shift;
  const { calculateEndTime, calculateLunchDuration } = useTimeCalculation();
  const memoizedCalculateEndTime = useCallback(calculateEndTime, []);
  const memoizedCalculateLunchDuration = useCallback(calculateLunchDuration, []);

  // se crea un objeto con los valores de configuración del turno para reducir la cantidad de dependencias del useEffect
  const shiftConfig = useMemo(
    () => ({
      flexibleShift,
      initialTime,
      workHours,
      lunchTime,
      imputableColation,
      agreedSchedule
    }),
    [workHours, lunchTime, imputableColation, flexibleShift, initialTime, agreedSchedule]
  );

  // Efecto para actualizar las horas de inicio y fin de los turnos
  useEffect(() => {
    if (shiftConfig.flexibleShift && shiftConfig.initialTime) {
      shiftDaysAttributes.forEach((_item, index) => {
        setFieldValue(`shift[shiftDaysAttributes][${index}][startTime]`, shiftConfig.initialTime);
        if (shiftConfig.workHours) {
          // Cuando la colación es por horario pactado, calcular duración desde startLunch/endLunch
          let effectiveLunchTime = shiftConfig.lunchTime || '0';
          if (shiftConfig.agreedSchedule) {
            const startLunch = shiftDaysAttributes[index].startLunch || '14:00';
            const endLunch = shiftDaysAttributes[index].endLunch || '15:00';
            effectiveLunchTime = String(memoizedCalculateLunchDuration(startLunch, endLunch));
          }
          const endTime = memoizedCalculateEndTime(
            shiftConfig.initialTime,
            shiftConfig.workHours,
            effectiveLunchTime,
            shiftConfig.imputableColation
          );
          setFieldValue(`shift[shiftDaysAttributes][${index}][endTime]`, endTime);
        }
      });
    }
  }, [shiftConfig, shiftDaysAttributes, memoizedCalculateEndTime, memoizedCalculateLunchDuration, setFieldValue]);

  return (
    <Card className="overflow-visible">
      <Col className={`${currentTab === 'flexibility' ? 'top-header-green' : 'top-header-light-gray'}`}>
        <Accordion.Toggle
          as={Col}
          eventKey="3"
          className="card-header-title-dt"
          onClick={() => onChangeTab('flexibility')}
        >
          Flexibilidad
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="3">
        <Card.Body className="div-content">
          <Row>
            <Col xs={12} md={4} className="mt-4 d-flex align-items-center">
              <Field name="shift[flexibleShift]">
                {({ field }) => (
                  <FormikCheckBox
                    {...field}
                    custom
                    field={field}
                    label="Turno flexible"
                    tooltipSize="23"
                    onClick={() => {
                      setFieldValue(field.name, field.value === 'true' || field.value === true);
                      setFieldValue('shift[tolerance]', 0);
                      setFieldValue('shift[parsedTolerance]', 0);
                      setFieldValue('shift[exitTolerance]', 0);
                      setFieldValue('shift[parsedExitTolerance]', 0);
                      setFieldValue('shift[uniqueAllDays]', !field.value);
                      if (field.value !== 'true' || field.value !== true) {
                        setFieldValue('shift[initialTime]', '');
                        setFieldValue('shift[maximumStartTime]', '');
                        setFieldValue('shift[workHours]', '');
                        setFieldValue('shift[agreedSchedule]', false);
                      }
                    }}
                    disabled={disabled}
                  />
                )}
              </Field>
            </Col>
            {flexibleShift && (
              <Col xs={12} md={4} className="mt-4 d-flex align-items-center">
                <Field name="shift[uniqueAllDays]">
                  {({ field }) => (
                    <FormikCheckBox
                      {...field}
                      custom
                      field={field}
                      label="Único para todos los días"
                      tooltipSize="23"
                      onClick={() => {
                        setFieldValue(field.name, field.value === 'true' || field.value === true);
                      }}
                      disabled
                    />
                  )}
                </Field>
              </Col>
            )}
          </Row>
          <Row>
            {flexibleShift && (
              <>
                <Col xs={4} md={2} className="ml-2">
                  <Field name="shift[initialTime]">
                    {({ field }) => (
                      <FormikTimeInput
                        {...field}
                        abbr
                        label="Hora de Inicio"
                        onChange={time => setFieldValue(field.name, time)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                        disabled={disabled}
                      />
                    )}
                  </Field>
                </Col>
                <Col xs={4} md={2} className="ml-2">
                  <Field name="shift[maximumStartTime]">
                    {({ field }) => (
                      <FormikTimeInput
                        {...field}
                        abbr
                        label="Tiempo Max. Inicio"
                        onChange={time => setFieldValue(field.name, time)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                        disabled={disabled}
                      />
                    )}
                  </Field>
                </Col>
                <Col xs={4} md={2} className="ml-2">
                  <Field name="shift[workHours]">
                    {({ field }) => (
                      <FormikTimeInput
                        {...field}
                        abbr
                        label="Horas Trabajo"
                        onChange={time => setFieldValue(field.name, time)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                        disabled={disabled}
                      />
                    )}
                  </Field>
                </Col>
              </>
            )}
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};
export default Flexibility;
